export const initialContractorDetails = {
  contactPhoneNumber: "",
  contractorName: "",
  emailAddress: "",
  mailingAddress: "",
  nameOfContact: "",
  phoneNumber: "",
  website: "",
};
export const initialDetails = {
  nickName: "",
  projectType: "",
  endDate: "",
  startDate: "",
  totalProjectDays: "",
  workingDays: "",
};
export const initialSubcontractorDetails = {
  ...initialContractorDetails,
};

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}


export function formatNumber(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
  } else if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
}